import { useState, useEffect, useCallback } from 'react';
import { getArticleBySlug } from '../services/manual.service';
import type { ManualArticle } from '../lib/supabase.types';

export function useManualArticle(slug: string, language: string = 'ja') {
  const [article, setArticle] = useState<ManualArticle | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | string | null>(null);

  const fetchArticle = useCallback(async () => {
    if (!slug) {
      setError(language === 'en' ? 'No article slug specified' : '記事のスラグが指定されていません');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await getArticleBySlug(slug, language);
      if (!result) {
        setError(
          language === 'en'
            ? `Article "${slug}" not found.`
            : `記事 "${slug}" が見つかりませんでした。`
        );
        setArticle(null);
      } else {
        setArticle(result);
        setError(null);
      }
    } catch (err) {
      console.error('Failed to load article:', err);
      setError(err as Error);
      setArticle(null);
    } finally {
      setLoading(false);
    }
  }, [slug, language]);

  useEffect(() => {
    fetchArticle();
  }, [fetchArticle]);

  return { article, loading, error, refetch: fetchArticle };
}
